
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface GeneralSettingsProps {
  settings: any;
  onSettingsChange: (settings: any) => void;
}

const GeneralSettings = ({ settings, onSettingsChange }: GeneralSettingsProps) => {
  return (
    <div className="space-y-6">
      <Card className="admin-card border-admin-border">
        <CardHeader>
          <CardTitle className="text-admin-card-foreground">Site Information</CardTitle>
          <CardDescription className="text-admin-muted-foreground">
            Basic information about your store
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="siteName" className="text-admin-card-foreground">Site Name</Label>
            <Input
              id="siteName"
              value={settings.siteName || ""}
              onChange={(e) => onSettingsChange({ siteName: e.target.value })}
              placeholder="Enter your site name"
              className="border-admin-border"
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="siteDescription" className="text-admin-card-foreground">Site Description</Label>
            <Textarea
              id="siteDescription"
              value={settings.siteDescription || ""}
              onChange={(e) => onSettingsChange({ siteDescription: e.target.value })}
              placeholder="Enter a brief description of your store"
              className="border-admin-border"
              rows={3}
            />
          </div>

          <div className="space-y-2">
            <Label htmlFor="contactEmail" className="text-admin-card-foreground">Contact Email</Label>
            <Input
              id="contactEmail"
              type="email"
              value={settings.contactEmail || ""}
              onChange={(e) => onSettingsChange({ contactEmail: e.target.value })}
              placeholder="contact@yourstore.com"
              className="border-admin-border"
            />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default GeneralSettings;
